import { Component } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { Router } from "@angular/router";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { Constants } from "../constants/constants";

@Component({
    selector: "authentication",
    templateUrl: "/app/authentication/authentication.template.html",
	providers: [AuthenticationService]
})
export class AuthenticationComponent {
	loginModel = {} as IAuthenticationModel;
	isLoggingIn = false;
	 userEmail: string | undefined;
	 user={} as IAuthenticationModel;
	
	//constructor(public authService: AuthService) {}
	constructor(private authService: AuthenticationService, private router: Router, private toast: ToastsManager, private constants: Constants) { }
	//login-Onload
	//ngOnInit(): void {
	//	// ✅ Automatically call login when the component loads
	//	this.login();
	//}	
	async login() {

		this.isLoggingIn = true;
		try {
			this.user= await this.authService.login();
		  

		  if (this.user.email !== null) {
			this.authService.getAirFreightRoles(this.user.email).subscribe((airfreightroles: number): void => {
				
				this.user.airfreightrole = airfreightroles;
			});

			  this.authService.getUserRoles(this.user.email).subscribe((roles: number): void => {
				  this.user.role = roles;
				  var encryptedUser = btoa(JSON.stringify(this.user));
				  localStorage.setItem("user", encryptedUser);
				  this.constants.user = this.user;
				  this.isLoggingIn = false;
				  let returnUrl = localStorage.getItem("returnUrl");
				  let url = !returnUrl ? "history" : returnUrl;
				  localStorage.removeItem("returnUrl");

				  this.router.navigate([url]);
			  });
			
		}
		else {
			this.toast.error("There was an error logging in. Please contact support", "Error", { toastLife: 10000 });
			this.isLoggingIn = true;
		}

		} catch (error) {
		  console.error('Authentication failed:', error);
		}
	  }
}